import { createAction } from '@reduxjs/toolkit';

export const removeCredentials = createAction('auth/removeCredentials');
